import React from 'react'
import { Link } from 'react-router-dom'
import type { RouteDef } from '@ztechapps/common.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import { Icon, ShowIf, TooltipPopOver } from '@ztechapps/webui.util'
import { useChannelContext } from '../Channel/Context'

export type ConversationDetailLinkProps = { conversationId?: string }

// Document-side chat panels mount against the conversation's external id; the thread read above
// already carries the code, so the jump takes it from the channel instead of its own lookup. An
// icon-only toolbar button beside Attach and Send — the code is the accessible name and the
// hover text, never visible text. Without a document-side conversation id there is nothing to
// jump to (the shared composer toolbar also serves the inbox thread), so nothing renders. The
// code arrives after the editor has measured its toolbar once, so the button holds its width
// `invisible` until then — appearing later would narrow the toolbar and wrap its overflow group.
export const ConversationDetailLink = ({ conversationId }: ConversationDetailLinkProps) => {
  const conversationItemRoute = useInject<RouteDef>(WebuiIocKey.routes.conversationItem)
  const { conversationCode } = useChannelContext()

  const label = conversationCode ? `View conversation ${conversationCode}` : ''

  return (
    <ShowIf condition={!!conversationId}>
      <TooltipPopOver tooltipBody={label}>
        <Link
          to={conversationItemRoute.altPath({ _id: conversationId ?? '' })}
          aria-label={label}
          className={`btn btn-link ${conversationCode ? '' : 'invisible'}`}
        >
          <Icon name="external-link" aria-hidden="true" />
        </Link>
      </TooltipPopOver>
    </ShowIf>
  )
}
